module.exports = __webpack_public_path__ + "static/media/product (12).cfa31f24.jpg";